import React, { useEffect, useState } from "react";
import "../Shopkeeper/css/price.css";

export default function Price() {
  const [pricing, setPricing] = useState([]);
  const [error, setError] = useState(null);
  const [showYearly, setShowYearly] = useState(false); // toggle state

  // helper to convert type -> readable label
  const getTypeLabel = (type) => {
    switch (type?.toLowerCase()) {
      case "monthly":
        return "month";
      case "weekly":
        return "week";
      case "daily":
        return "day";
      case "yearly":
        return "year";
      default:
        return type;
    }
  };

  const fetchPricingPlans = async () => {
    const url = `https://api.adoop.in/api/v2/subs/plans`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch pricing plans");
      }

      const data = await response.json();
      console.log("Pricing Plans:", data);
      setPricing(data);
    } catch (err) {
      console.error("Error fetching pricing plans:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchPricingPlans();
  }, []);

  // filter plans based on toggle
  const filteredPlans = pricing.filter((plan) => {
    if (showYearly) {
      return plan.type?.toLowerCase() === "yearly";
    } else {
      return plan.type?.toLowerCase() !== "yearly"; // monthly + weekly + daily
    }
  });

  return (
    <>
      <div class="preloader">
        <div class="preloader-inner">
          <div class="preloader-icon">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <header class="header navbar-area" style={{ padding: "12px" }}>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="nav-inner">
                <nav class="navbar navbar-expand-lg">
                  <a class="navbar-brand" href="https://adoop.in/index.html">
                    <img
                      src="assets/images/logo/black-white-logo.png"
                      alt="Logo"
                    />
                  </a>
                  <button
                    class="navbar-toggler mobile-menu-btn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                  </button>
                  <div
                    class="collapse navbar-collapse sub-menu-bar"
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" class="navbar-nav ms-auto">
                      <li class="nav-item">
                        <a href="https://adoop.in/index.html">Home</a>
                      </li>
                      <li class="nav-item">
                        <a href="https://adoop.in/index.html">Features</a>
                      </li>
                      <li class="nav-item">
                        <a href="https://adoop.in/about-us.html">About Us</a>
                      </li>

                      <li class="nav-item">
                        <a href="https://shopspromo.adoop.in/">BizList</a>
                      </li>
                      <li class="nav-item">
                        <a href="/pricing">Pricing</a>
                      </li>
                      <li class="nav-item">
                        <a href="https://adoop.in/contact-us.html">
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="button add-list-button">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.tes.shoponmobile.promotions.adoop&pcampaignid=web_share"
                      class="btn"
                      target="_blank"
                      contenteditable="false"
                      style={{ cursor: "pointer;" }}
                    >
                      <img
                        src="assets/images//download-btn/playstore.png"
                        class="img-fluid"
                        alt="playstore"
                        style={{ height: "26px", width: "26px" }}
                      />
                    </a>
                    &nbsp; &nbsp;
                    <a
                      href="https://apps.apple.com/in/app/adoop/id6739332196"
                      class="btn"
                      contenteditable="false"
                      style={{ cursor: "pointer;" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        class="bi bi-apple"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                        <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                      </svg>
                    </a>
                    &nbsp; &nbsp;
                    <a href="https://mybiz.adoop.in/" class="btn">
                      Login Now!
                    </a>
                    &nbsp; &nbsp;
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="page-banner">
        <div className="container">
          <h1 className="page-title">Pricing</h1>
          <div
            className="breadcrumb"
            style={{ fontSize: "16px", fontWeight: "600" }}
          >
            <a href="https://adoop.in/index.html">Home</a> <span>›</span>{" "}
            <span>Pricing</span>
          </div>
        </div>
      </section>

      <div className="container">
        <section style={{ paddingTop: "50px" }}>
          <div className="row">
            <section id="pricing" className="pricing section">
              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                {/* Toggle switch */}
                <div
                  className="pricing-toggle-container mb-5"
                  data-aos="zoom-in"
                  data-aos-delay="150"
                >
                  <div className="pricing-toggle d-inline-flex align-items-center gap-3 px-3 py-2 rounded-pill">
                    <span className={`monthly ${!showYearly ? "active" : ""}`}>
                      Monthly
                    </span>
                    <label className="switch m-0">
                      <input
                        type="checkbox"
                        aria-label="Toggle pricing"
                        checked={showYearly}
                        onChange={(e) => setShowYearly(e.target.checked)}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className={`yearly ${showYearly ? "active" : ""}`}>
                      Yearly
                    </span>
                  </div>
                </div>

                {/* Plans */}
                <div className="row gy-4" style={{ marginBottom: "50px" }}>
                  {filteredPlans.map((plan, index) => (
                    <div className="col-lg-4" key={plan.id}>
                      <article
                        className={`price-card h-100 ${
                          index === 1 ? "featured" : ""
                        }`}
                      >
                        <div className="card-head">
                          <span className="badge-title">{plan.name}</span>
                          <h3 className="title">{plan.name} Plan</h3>
                          <p
                            className="subtitle"
                            style={{ color: "var(--default-color)" }}
                          >
                            {plan.ads_limit}
                          </p>

                          <div className="price-wrap">
                                                                 <span className="price price-monthly">
  <span style={{ textDecoration: 'line-through', color: '#888', marginRight: '8px' }}>
    Rs.{plan.amount}
  </span>
  <span>
    {/* Rs.{plan.discount_amount} / {getTypeLabel(plan.type)} */}
    Rs.{plan.discount_amount}
  </span>
</span>
                          </div>
                        </div>

                        <ul className="feature-list list-unstyled mb-4">
                          <li>
                            <i className="bi bi-check-circle"></i> Validity:{" "}
                            {plan.validity} days
                          </li>
                          <li>
                            <i className="bi bi-check-circle"></i>Per Day:{" "}
                            {plan.ads}
                          </li>
                          <li>
                            <i className="bi bi-check-circle"></i> Total Ads:{" "}
                            {plan.total_ads}
                          </li>
                          <li>
                            <i className="bi bi-check-circle"></i>Plan Type:{" "}
                            {getTypeLabel(plan.type)}
                          </li>
                        </ul>


 <div className="cta">
                          <a
                            href="#"
                            className="btn btn-choose w-100"
                            target="_self"
                            rel="noopener noreferrer"
                           
                          >
                            {plan.name === "Free"
                              ? "Active Plan"
                              : "Coming Soon"}
                          </a>
                        </div>
                        {/* <div className="cta">
                          <a
                            href="#"
                            className="btn btn-choose w-100"
                            target="_self"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.preventDefault(); // stop default navigation
                              if (plan.name !== "Free") {
                                alert(
                                  `To buy the ${plan.name} plan, please login to continue.`
                                );
                                window.location.href = "/"; // redirect to home page
                              }
                            }}
                          >
                            {plan.name === "Free"
                              ? "Active Plan"
                              : `Choose ${plan.name}`}
                          </a>
                        </div> */}
                      </article>
                    </div>
                  ))}

                  {filteredPlans.length === 0 && (
                    <p className="text-center w-100">No plans available</p>
                  )}
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {/* footer */}
      <footer class="footer">
        <div class="container">
          <div class="row g-1 align-items-center p-3">
            <div class="col-md-5 text-center text-md-start mb-md-0">
              <span class="text-light">
                <i class="fas fa-copyright me-2"></i>Adoop, All right reserved.{" "}
              </span>
              <a
                href="https://adoop.in/privacy-policy.html"
                class="copyright"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Privacy policy |{" "}
              </a>

              <a
                href="https://adoop.in/terms-and-conditions.html"
                class="copyright"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                {" "}
                Terms &amp; Conditions |{" "}
              </a>

              <a
                href="https://adoop.in/faq.html"
                class="copyright"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                {" "}
                FAQ
              </a>
            </div>
            <div class="col-md-3">
              <div class="d-flex justify-content-center">
                <a
                  href="#"
                  target="_blank"
                  aria-label="linkdin"
                  class="btn btn-light-outline-0 btn-sm-square rounded-circle me-0"
                  contenteditable="false"
                  style={{ cursor: "pointer;" }}
                >
                  <i class="lni lni-linkedin-original text-light"></i>
                </a>
              </div>
            </div>
            <div class="col-md-4 text-center text-md-end text-white">
              <span class="text-light"> Powered By</span>{" "}
              <a
                class="border-bottom copyright"
                href="https://techexponentsystem.com/"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Tech Exponent System
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* end footer */}
    </>
  );
}
